import { render, staticRenderFns } from "./MortgageListingCount.vue?vue&type=template&id=4fb5a990"
import script from "./MortgageListingCount.vue?vue&type=script&lang=js"
export * from "./MortgageListingCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports